import { setAppLanguage } from "./setAppLanguage";
import { checkAndApplyUpdates } from "../expoUpdates";
import {loadAssets} from "./loadAssets";
import {setDeviceSettings} from "./setDeviceSettings";
import {setInitialAppData} from "./setInitialAppData";
import {initSocketService} from "../socket/socket";
import {STORAGE} from "../storage";
import {initSoketiService} from "../soketi";

export const initializeApp = async () => {
    console.log('Initializing App Instance');
    // device specific settings initialization
    await setDeviceSettings();

    // app specific settings initialization
    await loadAssets() // Load the assets
    await setAppLanguage(); // Set the app language
    await setInitialAppData(); // Set the initial app data

    const soketiUrl = await STORAGE.get("soketiUrl");
    if (soketiUrl) {
        await initSoketiService();
    } else {
        await initSocketService()
    }

    await checkAndApplyUpdates(); // Check for updates
};



